import { useState, useEffect } from 'react';
import { useUserDetails } from '../queries/useUserQueries';

export const useUserFormData = () => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [hasFormDetails, setHasFormDetails] = useState(false);
  
  // Use the direct endpoint to user details
  const { data: userFormDetails, isLoading, error } = useUserDetails();
  
  // Check if we have valid form details
  useEffect(() => {
    // Only set hasFormDetails if we actually have valid data with responses
    const hasValidDetails = !!userFormDetails 
      && Array.isArray(userFormDetails.responses)
      // && userFormDetails.responses.length > 0;
    
    setHasFormDetails(hasValidDetails);
  }, [userFormDetails]);
  
  const openDetailsModal = () => {
    setIsDetailsModalOpen(true);
  };
  
  const closeDetailsModal = () => {
    setIsDetailsModalOpen(false);
  };
  
  return {
    userFormDetails,
    isLoading,
    error,
    isDetailsModalOpen,
    openDetailsModal,
    closeDetailsModal,
    hasFormDetails
  };
};
